import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";
import { TimePicker } from "@material-ui/pickers";
import moment from "moment-timezone";

export default class CheckInDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <div style={{ display: "flex" }}>
              <div style={{ paddingRight: 5 }}>
                <TimePicker
                  ampm={false}
                  label={languages.tournament.checkInStartTime}
                  value={
                    this.props.checkInStart
                      ? moment(this.props.checkInStart, "HH:mm")
                      : null
                  }
                  onChange={this.props.handleCheckInStartTimeChange}
                  cancelLabel={languages.general.cancel}
                />
              </div>
              <div style={{ paddingLeft: 5 }}>
                <TimePicker
                  ampm={false}
                  label={languages.tournament.checkInEndTime}
                  value={
                    this.props.checkInEnd
                      ? moment(this.props.checkInEnd, "HH:mm")
                      : null
                  }
                  onChange={this.props.handleCheckInEndTimeChange}
                  cancelLabel={languages.general.cancel}
                />{" "}
              </div>
            </div>
          </DialogContent>
          {this.props.errorMessage && (
            <DialogActions>
              <div>
                <Typography style={{ color: "red" }}>
                  {this.props.errorMessage}
                </Typography>
              </div>
            </DialogActions>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
              disabled={
                this.props.checkInStart === "" || this.props.checkInEnd === ""
              }
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
